<template>
  <div id="app" class="text-right main">
    <!-- <helpCenter msg="Welcome to Your Vue.js App"/> -->
    <router-view />
  </div>
</template>

<script>
// import helpCenter from './components/helpCenter.vue'
export default {
  name: "App",
  // components: {
  //   helpCenter
  // },
  data() {
    return {
    };
  },
  created() {
  },

  mounted() {
      // 异步加载 Google Fonts：rel=stylesheet 会阻塞渲染（海外真机访问 googleapis 慢时导致长时间白屏），
      // 这里先用 media='print' 让浏览器不阻塞渲染，下载完成后再切回 all。
      const cssLink = document.createElement('link')
      cssLink.rel = 'stylesheet'
      cssLink.href = 'https://fonts.googleapis.com/css?family=Cairo:bold,200,300,400,500,600,700,800,900|Poppins:bold,200,300,400,500,600,700,800,900|Montserrat:bold,200,300,400,500,600,700,800,900|El Messiri:bold,200,300,400,500,600,700,800,900|Mada:bold,200,300,400,500,600,700,800,900|Oleo Script:bold,200,300,400,500,600,700,800,900'
      cssLink.media = 'print'
      cssLink.onload = function () {
        cssLink.media = 'all'
      }
      cssLink.onerror = function () {
        cssLink.remove()
      }
      document.getElementsByTagName('head')[0].appendChild(cssLink)
    },

  methods: {
  },
};
</script>
<style >
html[lang="ar"] .text-right {
  text-align: right;
}

*{
  margin: 0;
  padding: 0;
}

html,
body,
.main {
  height: 100%;
}

html[lang="zh"] .text-left {
  text-align: left;
}
.imgs {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>